import React from 'react';
import moment from 'moment';
import LockRoundedIcon from '@mui/icons-material/LockRounded';
import { useTranslation } from 'react-i18next';
import useUserInfo from '@src/hooks/useTtsUser';
import { StyledPackageV3 } from './index.style';
import UsedCredits from './UsedCredits';
import NextResetCycle from './NextResetCycle';
import ProgressBar from './ProgressBar';
// import CreditUsageRule from './CreditsUsageRule';
import ExpDate from '../components/ExpDate';

const PackageV3 = ({
  wallet,
  // hasV2Package,
  isMonthlyPackage,
  isMobile,
  isAutoRenewalPackage,
  totalCapturedRolloverCredits,
}) => {
  const {
    usedCredits,
    usedCreditsPercent,
    creditsPerCycle,
    totalCredits,
    hasNextResetCycle,
    nextResetAt,
    packageExpiryDate,
    purchasedTopUpCredits,
    capturedReferralCreditsCycle,
  } = wallet;
  const { ttsUser } = useUserInfo();
  const hasExpired =
    packageExpiryDate && moment(packageExpiryDate).isBefore(moment());
  const { i18n } = useTranslation();
  const { t } = i18n;

  const renderNote = () => (
    <div className="list-note">{t('contentTooltipLockCredits')}</div>
  );

  const renderNoteLockCreditForMobile = () => {
    if (ttsUser?.studio?.cycle?.isLocked)
      return (
        <div className="lock-cycle-notification">
          <LockRoundedIcon className="icon-lock-cycle" />
          {renderNote()}
        </div>
      );

    if (ttsUser?.studio?.topUp?.isLocked)
      return (
        <div className="lock-cycle-notification">
          <LockRoundedIcon className="icon-lock-cycle" />
          {renderNote()}
        </div>
      );

    return <></>;
  };

  return (
    <StyledPackageV3>
      {!hasExpired && (
        <>
          <UsedCredits
            usedCredits={usedCredits}
            totalCredits={totalCredits}
            creditsPerCycle={creditsPerCycle}
            purchasedTopUpCredits={purchasedTopUpCredits}
            isMobile={isMobile}
            isAutoRenewalPackage={isAutoRenewalPackage}
            hasNextResetCycle={hasNextResetCycle}
            totalCapturedRolloverCredits={totalCapturedRolloverCredits}
            capturedReferralCreditsCycle={capturedReferralCreditsCycle}
          />

          {isMobile && renderNoteLockCreditForMobile()}

          {hasNextResetCycle && !isMonthlyPackage && (
            <NextResetCycle
              creditsPerCycle={creditsPerCycle}
              nextResetAt={nextResetAt}
            />
          )}
          <ProgressBar value={usedCreditsPercent} />
        </>
      )}
      <ExpDate packageExpiryDate={packageExpiryDate} />
      {/* {hasV2Package && <CreditUsageRule />} */}
    </StyledPackageV3>
  );
};

export default PackageV3;
